/**
 * ChatButton - Floating action button to open the chatbot
 */

import { Box, Circle, HStack, Image, Text } from "@chakra-ui/react"
import logo from "@hydrologiq/shared/assets/logiq_button.png"
interface ChatButtonProps {
  onClick?: () => void
  showShortcut?: boolean
  expanded?: boolean
  enabled?: boolean
}

export const ChatButton = ({ onClick, showShortcut = true, expanded = false, enabled = true }: ChatButtonProps) => {
  return (
    <Box position="relative" zIndex={999} width={expanded ? "100%" : undefined}>
      <HStack width={expanded ? "100%" : undefined}>
        {/* <Circle
          size="32px"
          bg={enabled ? "linear-gradient(100deg, #39aed2 0%, #8f2eff 100%)" : undefined}
          _hover={
            enabled && onClick ? { bg: "linear-gradient(100deg, #8f2eff 0%, #0bc5ea 100%)", cursor: "pointer" } : {}
          }
          color="primary"
          fontSize="sm"
          fontWeight="bold"
          mr={showShortcut ? 4 : 0}
          onClick={onClick}
        >
          <Image src={logo} alt="Hydrologiq" width="90%" height="90%" objectFit="contain" />
        </Circle> */}
        <Box
          width="100%"
          // height="40px"
          bg={enabled ? "linear-gradient(100deg, #39aed2 0%, #8f2eff 100%)" : undefined}
          _hover={
            enabled && onClick ? { bg: "linear-gradient(100deg, #8f2eff 0%, #0bc5ea 100%)", cursor: "pointer" } : {}
          }
          color="primary"
          fontSize="sm"
          fontWeight="bold"
          mr={showShortcut ? 4 : 0}
          onClick={onClick}
        >
          <Image src={logo} alt="Logiq Platform Logo" objectFit="contain" />
        </Box>
        {enabled && expanded && (
          <Text color="white" _hover={{ cursor: "pointer" }} onClick={onClick}>
            Ask Hydrologiq
          </Text>
        )}
      </HStack>

      {/* Keyboard shortcut hint */}
      {enabled && showShortcut && (
        <Box
          position="absolute"
          bottom="0px"
          right="-18px"
          bg="primary"
          color="white"
          fontSize="2xs"
          px={2}
          py={0.5}
          borderRadius="md"
          opacity={0.9}
        >
          ⌘K
        </Box>
      )}
    </Box>
  )
}
